import { NewSessionsApiFunc, ApiError } from '@/api'

export default class AuthModule {
  accessToken?: string;
  refreshToken?: string;
  role?: string;
  companyId?: string;
  loginId?: string;

  async login(this: AuthModule, loginId: string | undefined, password: string | undefined): Promise<ApiError | undefined> {
    const { data, err } = await NewSessionsApiFunc().authenticateAdmin(loginId, password)

    if (err != null) {
      return err
    }
    this.accessToken = data?.token?.accessToken
    this.refreshToken = data?.token?.refreshToken
    this.role = data?.role || "company"
    this.loginId = loginId
    this.companyId = data?.companyId
    this.store()

    return undefined
  }

  isAuthed(this: AuthModule): boolean {
    if (this.role === "company" && this.companyId === undefined) {
      return false;
    }
    return this.accessToken && this.role ? true : false
  }

  setCompanyId(companyId?: string): void {
    this.companyId = companyId
    this.store()
  }

  async refresh(this: AuthModule): Promise<ApiError | undefined> {
    const { data, err } = await NewSessionsApiFunc().refreshToken(this.refreshToken)

    if (err != null) {
      this.clear()
      return err
    }
    this.accessToken = data?.accessToken
    this.refreshToken = data?.refreshToken
    this.store()

    return undefined
  }

  store() {
    localStorage.auth = JSON.stringify({
      accessToken: this.accessToken,
      refreshToken: this.refreshToken,
      role: this.role,
      companyId: this.companyId,
      loginId: this.loginId
    })
  }

  restore() {
    const auth = localStorage.auth && JSON.parse(localStorage.auth)
    if (!auth) {
      return
    }
    this.accessToken = auth.accessToken
    this.refreshToken = auth.refreshToken
    this.role = auth.role
    this.companyId = auth.companyId
    this.loginId = auth.loginId
  }

  clear() {
    localStorage.removeItem('auth')
    this.accessToken = undefined
    this.refreshToken = undefined
    this.role = undefined
    this.companyId = undefined
    this.loginId = undefined
  }
}
